const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "30+", label: "Projects Completed" },
  { value: "10+", label: "Countries Served" },
  { value: "1500+", label: "Different Medical Units Delivered" },
];

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/411a3bc25217bb739b975979abfd3ba6.jpeg"
          alt="ANDINI Hospital Solutions"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-32 pb-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase bg-amber-500/20 text-amber-400 border border-amber-500/40 mb-6">
            Established 2008 · Ankara, Turkey
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
            Complete Hospital
            <span className="block text-amber-400">Turnkey Solutions</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-10 max-w-xl">
            Specialized provider of ICU equipment, hospital furniture, urology &amp; radiology systems — delivering world-class healthcare infrastructure across the globe.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleScroll("#services")}
              className="whitespace-nowrap px-8 py-3.5 rounded-md font-semibold bg-amber-500 text-white hover:bg-amber-600 transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              Explore Services <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => handleScroll("#projects")}
              className="whitespace-nowrap px-8 py-3.5 rounded-md font-semibold border-2 border-white/60 text-white hover:bg-white/10 transition-all duration-200 cursor-pointer"
            >
              View Projects
            </button>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="relative z-10 w-full bg-black/50 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-white/20">
          {stats.map((s) => (
            <div key={s.label} className="text-center px-4">
              <div className="text-3xl md:text-4xl font-bold text-amber-400">{s.value}</div>
              <div className="text-sm text-gray-300 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
